/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ClassroomUserModifyGradeManualViewModel } from "../types/ClassroomUserModifyGradeManualViewModel.ts";

export const classroomUserModifyGradeManualViewModelSchema = z.object({
  value: z
    .string()
    .describe(
      "Valor da nota a ser atribuída manualmente ao aluno. Obrigatório.",
    )
    .nullish(),
  classroomDisciplineId: z.optional(
    z
      .number()
      .int()
      .describe(
        "ID da disciplina na sala de aula à qual a nota pertence. Obrigatório.",
      ),
  ),
  personId: z.optional(
    z
      .number()
      .int()
      .describe(
        "ID da pessoa (aluno) que receberá a nota modificada. Obrigatório.",
      ),
  ),
}) as unknown as ToZod<ClassroomUserModifyGradeManualViewModel>;
